var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-tool-tip',{staticClass:"security-info-tooltip",attrs:{"text":'המידע שלך מאובטח תחת הסטנדרטים הגבוהים ביותר של אבטחת מידע',"icon-path":"onboarding/icons/privacy.svg"}})}
var staticRenderFns = []

export { render, staticRenderFns }